import React, { useEffect, useContext } from 'react'
import IconTxtBtnArrow from '../../../../../img/icon-txt-btn-arrow.svg';
// import context
import { Context } from '../courseTemplates';

/**
 * Register button or replacement for the register button
 * @param {Object} catDetails - Details data for the current category
 * @param {string} courseDataJWT - JWT string containing course data for jquery functions
 * @param {number} course_record_id - Course instance method record id
 * @param {Object} courseProduct - Product id for the course product
 * @param {string} membershipPolicyPageLink - URL for the membership policy page
 * @param {string} classDate - Formatted string representing the course dates
 * @param {Object} restrictedEnrollmentCategories - Enrollment categories that have a course in the cart
 * @param {string} templateId - Course template method record id
 */
function RegisterButton({catDetails, courseDataJWT, course_record_id, courseProduct, membershipPolicyPageLink, classDate, restrictedEnrollmentCategories, templateId}) {
    // get our global context variables
    const value = useContext(Context);
    const { customerId } = value;

    /**
     * Get the register button or replacement JSX
     * @returns JSX
     */
    const getRegisterButton = () => {
        // if there is a replacement for the register button in the category data
        if(catDetails.buttonReplacement){
            return (
                <p>
                    {catDetails.buttonReplacement}
                    {catDetails.showViewRequirementsLink && membershipPolicyPageLink &&
                        <>
                            <a href={membershipPolicyPageLink}> View Requirements</a>
                        </>
                    }
                </p>
            )
        // if user is enrolled in the course with this this category
        } else if (catDetails.enrolled){
            return(
                <a className="magnific-popup text-btn-arrow" data-popuptype="cancel-registration" data-enrollmentid={catDetails.enrollmentRecordID} data-seatid={catDetails.seat.recordID} data-coursedates={classDate} href="">Cancel Registration<span className="link-arrow"><IconTxtBtnArrow/></span></a>
            )
        // if the user is waitlisted and are not eligible to register for the course
        } else if (catDetails.waitlisted && !catDetails.canRegisterFromWaitlist){
            return(
                <a href="#" className="magnific-popup btn c-btn--light" data-popuptype="cancel-waitlist" data-waitlistid={catDetails.waitlistRecordID}>Remove from Waitlist</a>
            )
        // if the user can join the waitlist
        } else if (catDetails.canWaitlist){
            return(
                <a href="#" data-customerid={customerId} data-courseid={course_record_id} data-categoryid={catDetails.enrollmentCategoryInstanceRecordId} className="join-waitlist btn c-btn--light s-btn--sml">
                    Join Waitlist
                </a>
            )
        // if the user can register and they have the course in their cart already
        } else if (catDetails.canRegister && restrictedEnrollmentCategories && restrictedEnrollmentCategories[catDetails.enrollmentCategoryRecordId]){
            return(
                <p dangerouslySetInnerHTML={{__html: restrictedEnrollmentCategories[catDetails.enrollmentCategoryRecordId]}}/>
            )
        // if the user can register or they are waitlisted and can register
        } else if (catDetails.canRegister || (catDetails.waitlisted && catDetails.canRegisterFromWaitlist)){
            if(courseProduct){
                let registerButtonClass ="";
                if(catDetails.showCIpopup) {
                    registerButtonClass = "invoke-ci-popup seating-popup";
                }else if (catDetails.canAttendPortionOfClass){
                    registerButtonClass = "invoke-portion-of-class-popup seating-popup";
                }else{
                    if(catDetails.sittingInConferenceRoom) {
                        registerButtonClass = "skip-seating-chart";
                    }else{
                        registerButtonClass = "seating-popup";
                    }
                }
                // if they are waitlisted and can register
                if(catDetails.waitlisted && catDetails.canRegisterFromWaitlist){
                    return(
                        <>
                            <a href="#" className={`btn c-btn--light s-btn--sml add-course-to-cart ${(catDetails.showCIpopup)? "invoke-ci-popup seating-popup": ""} ${(catDetails.canAttendPortionOfClass)? "invoke-portion-of-class-popup seating-popup" : catDetails.sittingInConferenceRoom ? "skip-seating-chart" : "seating-popup"}`}
                                data-courseproductid={courseProduct.ID}
                                data-customerid={customerId}
                                data-courseid={catDetails.enrollmentCategory.Course_Id}
                                data-categoryid={catDetails.enrollmentCategoryRecordId}
                                data-roomnameoverride={catDetails.unassignedSeatingRoomName}
                                data-templateid={templateId}
                                data-jwt={courseDataJWT}
                                >
                                Register from Waitlist
                            </a>
                            <br/>
                            <a href="#" className="magnific-popup" data-popuptype="cancel-waitlist" data-waitlistid={catDetails.waitlistRecordID}>Remove from Waitlist</a>
                        </>
                    )
                // if they can register and are not waitlisted
                } else {
                    return (
                        <a className={`btn c-btn--light add-course-to-cart ${registerButtonClass}`}
                        data-courseproductid={courseProduct.ID}
                        data-customerid={customerId}
                        data-courseid={catDetails.enrollmentCategory.Course_Id}
                        data-categoryid={catDetails.enrollmentCategoryRecordId}
                        data-roomnameoverride={catDetails.unassignedSeatingRoomName}
                        data-templateId={templateId}
                        data-jwt={courseDataJWT}
                        >Register</a>
                    )
                }
            // default output if there is an error and the user is waitlist
            } else {
                return (
                    <>
                        <p>An error occurred, registration won't be possible at this time. Please contact an administrator if this persists.</p>
                        {catDetails.waitlisted && catDetails.canRegisterFromWaitlist &&
                            <a href="#" className="magnific-popup" data-popuptype="cancel-waitlist" data-waitlistid={catDetails.waitlistRecordID}>Remove from Waitlist</a>
                        }
                    </>
                )
            }
        // catch-all if there is an error
        } else {
            return (
                <p>An error occurred. Please contact an administrator if this persists.</p>
            )
        }
    }

    // need to register some jQuery event listeners, this is mostly
    // for pop ups
    useEffect(() => {
        // trigger the jquery to initiate the register button
        const InitSeatingPopupsEv = new Event('initSeatingPopups');
        document.body.dispatchEvent(InitSeatingPopupsEv);
        // trigger pop up init event, this is needed for some cases of the register
        // button replacement, like cancel-waitlist
        const InitPopUpsEvent = new Event('initPopups');
        document.body.dispatchEvent(InitPopUpsEvent);
        // this is also needed for some of the register button cases
        // one example is join-waitlist
        initCourseEventHandlers()
    },[]);

    // Component level JSX return statement ******************************************************
    return(
        <>
            {getRegisterButton()}
        </>
    )
}

export default RegisterButton;